<script setup lang="ts">
const { $modal } = useNuxtApp()
</script>

<template>
  <div class="h-48">
    <div class="absolute bottom-0 w-full">
      <div class="h-64 bg-gradient-to-b from-transparent to-white" />

      <div class="bg-white">
        <div class="relative -top-10 flex flex-col items-center">
          <p class="mb-5 text-2xl font-bold">Continue reading</p>

          <BaseButton variant="primary" @click="$modal.open('requestATrial')">
            Request a trial
          </BaseButton>

          <p class="mt-8 text-base font-normal">
            Already a subscriber?
            <button
              class="font-inter text-p-500 underline"
              @click.prevent="$modal.open('login')"
            >
              Login
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
